"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TextStyled = styled_components_1.default.span `
  color: ${props => { var _a; return (((_a = props.color) === null || _a === void 0 ? void 0 : _a.includes('--')) ? `var(${props.color}, '#000')` : props.color); }};
  font-weight: ${props => (props.bold ? '500' : 'normal')};
  font-size: ${props => props.size || 13}px;
  display: flex;
  height: 100%;
  align-items: center;
`;
